export default "__VITE_ASSET__3f534e8e__"